import React from "react";
import { PanelShopAds } from "../../UI/ShopAds/View/PanelShopAds";

const ShopADSView = () => {
  return <PanelShopAds />;
};

export default React.memo(ShopADSView);
